/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import { Input, InputNumber } from 'antd';

class Checkboxlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: new Date(),
            error: [],
            value: false,
            feild: {},
        };
        this.inputChange = this.inputChange.bind(this);
        this.inputnumberChange = this.inputnumberChange.bind(this);
        this.inputBlur = this.inputBlur.bind(this);
    }
    componentDidMount() {
        let { feild_data } = this.props;
        this.setState({ 'feild': feild_data, 'value': feild_data.value })
    }
    componentDidUpdate(prevProps, prevState) {
        let prev_value = prevState.value
        let { feild_data } = this.props;
        if (feild_data.value !== prev_value) {
            this.setState({ 'feild': feild_data, 'value': feild_data.value })
        }
    }
    componentWillUnmount() {
        this.setState({
            date: new Date(),
            error: [],
            value: false,
            feild: {}
        })
    }

    inputChange(evnt) {
        this.setState((state) => ({ 'value': state.value ? false : true }));
        // evnt.preventDefault();
    }
    inputnumberChange(value) {
        this.setState({ 'value': value });
    }
    inputBlur() {
        let { value, error } = this.state;
        let { feild_data } = this.props;
        feild_data['value'] = value;
        feild_data['error'] = error;
        this.props.inputChange(feild_data)
    }

    render() {
        let { feild_data } = this.props;
        let { value } = this.state;
        return (
            <React.Fragment>

                <div className={`${ feild_data.className ? feild_data.className : 'col-12'} form-group`}>
               
                {/* {feild_data.visible && */}
                    <label>
                        <input
                            type="checkbox"
                            checked={value}
                            name={feild_data.name}
                            onChange={this.inputChange}
                            onBlur={this.inputBlur}
                            disabled={feild_data.disable ? feild_data.disable : false} />
                        <span></span>
                    </label>
                    <label htmlFor={feild_data.name}> {feild_data.title} </label>
                {/* } */}

                {/* {feild_data.type === 'password' && <Input.Password placeholder={feild_data.placeholder} onChange={this.inputChange} onBlur={this.inputBlur} />}
                    {(feild_data.type !== 'password' && feild_data.type !== 'inputSubmit' && feild_data.type !== 'number') && <Input placeholder={feild_data.placeholder} defaultValue={feild_data.value} onChange={this.inputChange} onBlur={this.inputBlur} />}
                    {feild_data.type === 'number' && <InputNumber formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={value => value.replace(/\$\s?|(,*)/g, '')} min={0} placeholder={feild_data.placeholder} onChange={this.inputnumberChange} onBlur={this.inputBlur} />}
                    {(feild_data.type === 'inputSubmit') && <Input.Search defaultValue={feild_data.value} disabled={feild_data.disable ? feild_data.disable : false} placeholder={feild_data.placeholder} enterButton="Submit" onChange={this.inputChange} onSearch={this.inputBlur} />}
                    {(feild_data.error) && <small id={feild_data.name} className="form-text text-danger">{feild_data.error}</small>} */}
                {/* <input type={feild_data.type} className={feild_data.class['input']} id={feild_data.name} name={feild_data.name} placeholder={feild_data.placeholder} value={feild_data.value} onChange={this.inputChange} onBlur={this.inputBlur} /> */}
                </div>

            </React.Fragment>
        );
    }
}

export default Checkboxlayer;
